<script setup lang="ts">
const props = defineProps<{ adv: AdvCard }>();

const classes = computed(() => {
  switch (props.adv.theme) {
    case "yellow":
      return {
        wrapper: "bg-yellow-30 text-red-50",
        container: "bg-yellow-20",
      };
    case "light-blue":
      return {
        wrapper: "bg-beige-20 text-green-50",
        container: "bg-seagreen-10",
      };
    default:
      return {
        wrapper: "",
        container: "",
      };
  }
});
</script>

<template>
  <section class="w-full sm:py-16" :class="classes.wrapper">
    <UContainer class="grid grid-cols-1 [--ui-container-inline-padding:0] xs:grid-cols-2">
      <div :class="classes.container" class="flex flex-col items-start justify-center gap-6 px-12 py-16 md:px-24">
        <span
          v-if="adv.tags"
          class="text-sm font-light tracking-wider uppercase"
          v-text="adv.tags"
        />
        <CrystallizeImage
          :image="adv.icon"
          aria-hidden="true"
          class="w-24"
        />
        <h3 class="text-xl font-semibold" v-text="adv.title" />
        <div v-html="adv.text" />
        <NuxtLink
          v-for="item in adv.link"
          :key="item.url"
          :to="item.url"
          class="flex items-center gap-4 text-lg font-semibold transition-transform duration-300 first-of-type:mt-4 first-of-type:mb-[-1.4rem] md:-translate-x-12 md:no-underline md:hover:translate-x-0"
        >
          <UIcon
            name="fal:arrow-right-long"
            class="hidden md:inline"
            size="1.75em"
          />
          {{ item?.label }}
        </NuxtLink>
      </div>
      <CrystallizeImage :image="adv.img" img-class="size-full object-cover" />
    </UContainer>
  </section>
</template>
